import React, { useState, useEffect } from "react";
import "../../styles/modal.css";

export default function ClientWalletModal({ open, client, mode, onClose, onSubmit }) {
  const [amount, setAmount] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (open) {
      setAmount("");
      setDescription("");
    }
  }, [open]);

  if (!open || !client) return null;

  const isIncrease = mode === "increase";

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      id_user: client.user.id,
      amount: Number(amount),
      description: description
    });
  };

  return (
    <div className="modalOverlay" onClick={onClose}>
      <div className="modalCard" onClick={(e) => e.stopPropagation()}>
        <div className="modalHeader">
          <h3>{isIncrease ? "Recharger le compte" : "Retirer du solde"}</h3>
          <p className="userSub">Client: {client.user?.firstName} {client.user?.lastName}</p>
        </div>

        <form onSubmit={handleSubmit} className="modalForm">
          <div className="modalSection">
             <div className="formGroup">
                <label>Solde actuel</label>
                <input type="text" value={`${client.balance || 0} CFA`} disabled className="disabledInput" />
             </div>

            <div className="formGrid">
              <div className="formGroup">
                <label>Montant (CFA)</label>
                <input
                  type="number"
                  placeholder="Ex: 5000"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  required
                  min="1"
                />
              </div>

              <div className="formGroup">
                <label>Motif / Description</label>
                <input
                  type="text"
                  placeholder="Ex: Rechargement agence"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  required
                />
              </div>
            </div>
          </div>

          <div className="modalActions">
            <button type="button" className="btnGhost" onClick={onClose}>Annuler</button>
            <button className={`btnPrimary ${!isIncrease ? "btnDanger" : ""}`}>
              {isIncrease ? "Confirmer l'ajout" : "Confirmer le retrait"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}